import {
  Directive,
  inject,
  input
} from '@angular/core';

import { TabComponent } from './tab.component';

import type { InputSignal } from '@angular/core';

@Directive({
  selector: 'td-wb-tab[tdWbTabStateName]'
})
export class TabStateNameDirective<T> {
  readonly stateName: InputSignal<string> = input<string>('', { alias: 'tdWbTabStateName' });
  readonly stateParams: InputSignal<Record<string, string>> = input<Record<string, string>>(undefined, { alias: 'tdWbTabStateParams' });

  private readonly tabComponent = inject(TabComponent, { host: true });

  getTabId(): T {
    return this.tabComponent.getTabId();
  }

  getStateName(): string {
    return this.stateName() === '' ? undefined : this.stateName();
  }

  getStateParams(): Record<string, string> {
    return this.stateParams();
  }
}
